export default {
  'terms-of-use': {
    'title': 'Terms & Conditions',
  },
  'privacy-policy': {
    'title': 'Privacy Policy',
  },
  'rate-ios': 'Rate Booksy in App Store',
  'rate-android': 'Rate Booksy in Google Play',
  'delete-your-account': {
    'submit-request-title': 'Are you sure you want to delete your account?',
    'submit-request-description': 'Sending this request will permanently close and delete your account.',
    'submit-request-policy-info': 'Your personal information will be permanently deleted, except for the information we\'re legally required or permitted to keep, as outlined in our Privacy Policy.',
    'submit-request-subscription-note': 'Submitting this request will not cancel your billing subscription through Apple. To cancel your subscription, go to the App Store or ',
    'submit-request-subscription-info': 'Submitting this request will not cancel your billing subscription through {provider}. To cancel your subscription, go to the {store} or ',
    'click-here-for-instructions': 'click here for instructions',
    'submit-request-btn': 'Submit Request',
    'delete-account-modal': {
      'title': 'Are you sure you want to delete your account?',
      'description': 'Once you submit this request to close and delete your account, and the CS team processes it, you will no longer be able to log in or access your account information.',
    },
    'delete-account-and-businesses-modal': {
      'title': 'Are you sure you want to delete your account and related businesses?',
      'description': 'Once you submit this request to close and delete your account, and the CS team processes it, you will no longer be able to log in or access your account information. All businesses related to your account will be removed as well.',
    },
    'procesing-title': 'We are processing your request',
    'procesing-description': 'Our Service Team is reviewing your request. This may take a few days.',
    'procesing-verify-description': 'Our Service Team will review your request, and then contact you to verify your identity. This may take a few days.',
  },
}
